module.exports = __webpack_public_path__ + "media/images/new_entry_lead-5cbdeb62014698fa70ee750fab3a7d92.png";